// extracted by mini-css-extract-plugin
export default {"tabs":"D--z","tablist":"E--z","tablistItem":"F--z"};